import { render, staticRenderFns } from "./PosterCardViewer.vue?vue&type=template&id=6b1f461e"
import script from "./PosterCardViewer.vue?vue&type=script&lang=ts"
export * from "./PosterCardViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports